export default __webpack_public_path__ + "static/media/home.ab3d29a6.svg";